import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';
var cookie = require('react-cookie');

class UserProfileStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.profile = [];

  }

  handleLoadSuccess(profile) {
    this.profile = profile;
    this.emitChange();
  }
  /* handleLoadTrendingSuccess(trendingList) {
       this.trending = trendingList;
       this.emitChange();
   }*/
  get() {
    return {
      profile: this.profile
    };
  }

  dehydrate() {
    return {
      profile: this.profile
    };
  }

  rehydrate(state) {
    this.profile = state.profile;
  }
}

UserProfileStore.storeName = 'UserProfileStore';
UserProfileStore.handlers = {
  [Actions.LOAD_PROFILE_SUCCESS]: 'handleLoadSuccess',
/* [Actions.LOAD_SERVICETRENDING_SUCCESS]: 'handleLoadTrendingSuccess',*/
};

export default UserProfileStore;


// WEBPACK FOOTER //
// ./src/stores/UserProfileStore.js